import React from 'react';
import { Trans, TransProps } from 'react-i18next';

export const DashboardActionsCardLabel = (props: TransProps) => (
  <Trans {...props} />
);
